/*
 * Allstars 2027 motion layer.
 * - Intro loader (once per visit)            -> html.as-intro
 * - Red page-change screen (leave + arrive)  -> html.as-arriving
 * - MODELS / ITEMS toggle                     -> html.as-view-items
 * - Size guide / notify-me dialogs
 * - Card scroll reveal
 * The neon intro and page change use the Web Animations API (no library). GSAP 3 (assets/gsap.min.js) is only
 * loaded for the older red loader styles. Everything degrades to CSS if neither is available,
 * and prefers-reduced-motion skips the loader and swaps the wipe for a fade.
 */
(function () {
  'use strict';

  var html = document.documentElement;
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = (function () {
    try { return window.sessionStorage; } catch (e) { return null; }
  })();
  var local = (function () {
    try { return window.localStorage; } catch (e) { return null; }
  })();

  function gsapReady() { return typeof window.gsap !== 'undefined'; }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function shuffle(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function rand(min, max) { return Math.random() * (max - min) + min; }

  /* ------------------------------------------------------------------ */
  /* Page entrance (after the loader or the red screen)                  */
  /* ------------------------------------------------------------------ */
  function playEntrance() {
    html.classList.add('as-entering');
    window.setTimeout(function () { html.classList.remove('as-entering'); html.classList.add('as-entered'); }, 1400);
    document.dispatchEvent(new CustomEvent('as:entered'));
  }

  /* ------------------------------------------------------------------ */
  /* Intro loader                                                        */
  /* ------------------------------------------------------------------ */
  function runIntro() {
    var loader = $('[data-as-intro]');
    if (!html.classList.contains('as-intro') || !loader) return false;
    if (store) store.setItem('dnba_intro_seen', '1');

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      html.classList.remove('as-intro');
      loader.remove();
      playEntrance();
      document.dispatchEvent(new CustomEvent('as:intro-done'));
    }

    if (loader.getAttribute('data-style') === 'neon' && loader.animate) {
      // Neon sign with the Web Animations API (no GSAP, so nothing heavy to download):
      // draw the tube, one soft dip (photosensitive-safe), light up, power cut.
      var svg = $('.as-neon__svg', loader);
      var path = $('path', loader);
      var L = path.getTotalLength ? path.getTotalLength() : 1000;
      var T = 2420;
      path.style.strokeDasharray = L;
      path.style.strokeDashoffset = L;
      var anims = [
        path.animate([
          { strokeDashoffset: L, offset: 0 },
          { strokeDashoffset: L, offset: 0.062, easing: 'ease-in-out' },
          { strokeDashoffset: 0, offset: 0.517 },
          { strokeDashoffset: 0, offset: 1 }
        ], { duration: T, fill: 'forwards' }),
        path.animate([
          { fill: 'transparent', offset: 0 },
          { fill: 'transparent', offset: 0.661 },
          { fill: 'currentColor', offset: 0.744 },
          { fill: 'currentColor', offset: 1 }
        ], { duration: T, fill: 'forwards' }),
        svg.animate([
          { opacity: 1, offset: 0 },
          { opacity: 1, offset: 0.537, easing: 'ease-in-out' },
          { opacity: 0.55, offset: 0.595, easing: 'ease-in-out' },
          { opacity: 1, offset: 0.653 },
          { opacity: 1, offset: 0.888, easing: 'ease-in' },
          { opacity: 0, offset: 0.938 },
          { opacity: 0, offset: 1 }
        ], { duration: T, fill: 'forwards' })
      ];
      anims[2].onfinish = finish;
      function skipNeon() {
        document.removeEventListener('keydown', skipNeon);
        anims.forEach(function (a) { try { a.finish(); } catch (err) {} });
        finish();
      }
      loader.addEventListener('click', skipNeon, { once: true });
      document.addEventListener('keydown', skipNeon);
      return true;
    }

    if (!gsapReady()) {
      html.classList.add('as-intro-css');
      window.setTimeout(finish, 2600);
      return true;
    }

    var gsap = window.gsap;
    var cards = $$('.as-intro-loader__card', loader);
    var chars = $$('.as-char', loader);
    var count = $('.as-count', loader);
    var counter = { v: 0 };

    gsap.set(cards, { scale: 0, rotation: 0, x: 0, y: 0 });
    gsap.set(chars, { y: 0, yPercent: 110 });

    var tl = gsap.timeline({ onComplete: finish });
    tl.to(cards, {
      scale: 1,
      rotation: function () { return rand(-20, 20); },
      duration: 0.6,
      ease: 'power3.out',
      stagger: 0.2
    }, 0.4)
      .to(shuffle(chars), { yPercent: 0, duration: 0.6, ease: 'power3.out', stagger: 0.2 / Math.max(1, chars.length / 6) }, 0.4)
      .to(counter, {
        v: 100,
        duration: 2.4,
        ease: 'circ.inOut',
        onUpdate: function () { if (count) count.textContent = String(Math.round(counter.v)).padStart(3, '0'); }
      }, 0)
      .addLabel('exit', 2.2)
      .to(count, { yPercent: -100, opacity: 0, duration: 0.8, ease: 'circ.inOut' }, 'exit')
      .to(shuffle(chars), { yPercent: -120, duration: 1.0, ease: 'expo.inOut', stagger: 0.06 }, 'exit')
      .to(cards.slice().reverse(), {
        scale: 0,
        rotation: function () { return rand(-20, 20); },
        duration: 0.5,
        ease: 'expo.inOut',
        stagger: 0.08
      }, 'exit')
      .to(loader, { clipPath: 'inset(0% 0% 100% 0%)', duration: 1.2, ease: 'power2.inOut' }, 'exit+=0.3');

    // Skip on click / tap / Esc
    function skip() {
      tl.progress(1);
      finish();
    }
    loader.addEventListener('click', skip, { once: true });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { document.removeEventListener('keydown', onKey); skip(); }
    });
    return true;
  }

  /* ------------------------------------------------------------------ */
  /* Page-change screen                                                  */
  /* ------------------------------------------------------------------ */
  var overlay = $('[data-as-transition]');
  var leaving = false;
  var NEON = !!(overlay && overlay.getAttribute('data-style') === 'neon');
  var NT_LABELS = {};
  if (NEON) {
    try {
      var raw = JSON.parse(($('#AsNeonLabels') || {}).textContent || '{}');
      Object.keys(raw).forEach(function (k) { NT_LABELS[k.toLowerCase().replace(/\/+$/, '')] = raw[k]; });
    } catch (err) { NT_LABELS = {}; }
  }

  // Which word the neon sign spells for a link ('' = the dnb logo)
  function neonLabel(a, url) {
    var p = url.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '').replace(/\/+$/, '').toLowerCase();
    if (!p) return '';
    if (NT_LABELS[p]) return NT_LABELS[p];
    if (/^\/collections\/[^/]+/.test(p)) {
      var own = (a.getAttribute('data-as-label') || '').trim();
      if (own) return own.toUpperCase();
      if (!a.closest('.card, .grid__item, .as-nation')) {
        var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (t && t.length <= 16) return t.toUpperCase();
      }
      return p.split('/')[2].replace(/-\d+$/, '').replace(/-/g, ' ').toUpperCase();
    }
    return '';
  }

  function fitWord() {
    var svg = $('.as-nt__word', overlay), t = $('[data-as-nt-text]', overlay);
    if (!svg || !t || !t.textContent) return;
    try {
      var b = t.getBBox();
      if (b.width) svg.setAttribute('viewBox', (b.x - 24) + ' ' + (b.y - 24) + ' ' + (b.width + 48) + ' ' + (b.height + 48));
    } catch (err) {}
  }

  function neonParts() {
    var word = overlay.getAttribute('data-mode') === 'word';
    return {
      box: word ? $('.as-nt__word', overlay) : $('.as-nt__logo', overlay),
      strokes: word ? [$('[data-as-nt-text]', overlay)] : $$('.as-nt__svg path', overlay),
      word: word
    };
  }

  function shouldIntercept(e, a) {
    if (!overlay || leaving) return false;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (!a || !a.href || a.hasAttribute('download')) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.closest('[data-no-transition], dialog')) return false;
    var url;
    try { url = new URL(a.href, window.location.href); } catch (err) { return false; }
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return false; // anchors / same page
    if (/^\/(cart|checkout|checkouts|account|services|apps|tools|admin|search)(\/|$)/.test(url.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, ''))) return false;
    if (url.search.indexOf('preview_theme_id') > -1) return true;
    return true;
  }

  function leave(url, a) {
    leaving = true;
    if (store) store.setItem('dnba_transition', '1');
    var go = function () { window.location.href = url; };

    if (NEON) {
      var label = '';
      try { label = neonLabel(a || document.body, new URL(url, location.href)); } catch (err) {}
      if (store) { try { store.setItem('dnba_transition_label', label); } catch (err) {} }
      overlay.setAttribute('data-mode', label ? 'word' : 'logo');
      overlay.classList.remove('is-lit');
      var tx = $('[data-as-nt-text]', overlay);
      if (tx) tx.textContent = label;
      fitWord();
      if (REDUCE || !overlay.animate) {
        overlay.classList.add('is-lit');
        overlay.style.visibility = 'visible';
        overlay.style.opacity = '1';
        window.setTimeout(go, REDUCE ? 150 : 350);
        return;
      }
      // Quick and photosensitive-safe: draw, one soft dip, light up, go (about 0.6s). Web Animations, no GSAP.
      var n = neonParts();
      overlay.style.visibility = 'visible';
      overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 120, fill: 'forwards' });
      n.strokes.forEach(function (el) {
        var L = n.word ? 1000 : (el.getTotalLength ? el.getTotalLength() : 1000);
        el.style.strokeDasharray = L;
        el.animate([
          { strokeDashoffset: L, offset: 0 },
          { strokeDashoffset: L, offset: 0.067, easing: 'ease-in-out' },
          { strokeDashoffset: 0, offset: 0.667 },
          { strokeDashoffset: 0, offset: 1 }
        ], { duration: 600, fill: 'forwards' });
      });
      n.box.style.opacity = '1';
      n.box.animate([
        { opacity: 1, offset: 0 },
        { opacity: 1, offset: 0.633, easing: 'ease-in-out' },
        { opacity: 0.6, offset: 0.767, easing: 'ease-in-out' },
        { opacity: 1, offset: 0.9 },
        { opacity: 1, offset: 1 }
      ], { duration: 600 });
      window.setTimeout(function () { overlay.classList.add('is-lit'); }, 520);
      window.setTimeout(go, 600);
      return;
    }

    if (REDUCE || !gsapReady()) {
      html.classList.add('as-leaving-fade');
      window.setTimeout(go, REDUCE ? 150 : 450);
      return;
    }
    var gsap = window.gsap;
    var chars = $$('.as-char', overlay);
    var page = $('.page-wrapper') || $('.main');
    gsap.set(overlay, { clipPath: 'inset(100% 0% 0% 0%)', visibility: 'visible' });
    gsap.set(chars, { y: 0, yPercent: 110 });
    var tl = gsap.timeline({ onComplete: go });
    tl.to(page, { opacity: 0.9, scale: 0.94, y: '-8vh', duration: 0.7, ease: 'power3.inOut', transformOrigin: '50% 0%' }, 0)
      .to(overlay, { clipPath: 'inset(0% 0% 0% 0%)', duration: 0.7, ease: 'power3.inOut' }, 0)
      .to(shuffle(chars), { yPercent: 0, duration: 0.5, ease: 'power2.inOut', stagger: 0.05 }, 0.15);
    // Safety: never trap the shopper
    window.setTimeout(go, 1600);
  }

  function arrive() {
    if (!html.classList.contains('as-arriving') || !overlay) {
      if (html.classList.contains('as-arriving-fade')) {
        window.setTimeout(function () { html.classList.remove('as-arriving-fade'); }, 150);
      }
      return false;
    }
    function done() {
      html.classList.remove('as-arriving');
      if (gsapReady()) window.gsap.set(overlay, { clearProps: 'all' });
      $$('.as-char', overlay).forEach(function (c) { c.removeAttribute('style'); });
      if (NEON) {
        if (overlay.getAnimations) overlay.getAnimations({ subtree: true }).forEach(function (an) { an.cancel(); });
        overlay.classList.remove('is-lit');
        overlay.removeAttribute('style');
        $$('.as-nt__logo, .as-nt__word, .as-nt__svg path, [data-as-nt-text]', overlay).forEach(function (el) { el.removeAttribute('style'); });
      }
    }
    if (NEON) {
      fitWord();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitWord);
      if (!overlay.animate) { window.setTimeout(done, 500); playEntrance(); return true; }
      // Power cut: the sign goes off once, then the page shows (about 0.4s).
      var n = neonParts();
      overlay.classList.add('is-lit');
      overlay.style.visibility = 'visible';
      overlay.style.opacity = '1';
      n.box.animate([
        { opacity: 1, offset: 0 },
        { opacity: 1, offset: 0.25, easing: 'ease-in' },
        { opacity: 0, offset: 0.5 },
        { opacity: 0, offset: 1 }
      ], { duration: 400, fill: 'forwards' });
      var oa = overlay.animate([
        { opacity: 1, offset: 0 },
        { opacity: 1, offset: 0.45, easing: 'ease-out' },
        { opacity: 0, offset: 1 }
      ], { duration: 400, fill: 'forwards' });
      window.setTimeout(playEntrance, 180);
      oa.onfinish = done;
      return true;
    }
    if (!gsapReady()) {
      window.setTimeout(done, 700);
      playEntrance();
      return true;
    }
    var gsap = window.gsap;
    var chars = $$('.as-char', overlay);
    gsap.set(overlay, { clipPath: 'inset(0% 0% 0% 0%)' });
    gsap.set(chars, { y: 0, yPercent: 0 });
    var tl = gsap.timeline({ onComplete: done });
    tl.to(shuffle(chars), { yPercent: -110, duration: 0.45, ease: 'power2.inOut', stagger: 0.05 }, 0)
      .to(overlay, { clipPath: 'inset(0% 0% 100% 0%)', duration: 0.7, ease: 'power3.inOut' }, 0.2)
      .add(playEntrance, 0.62);
    return true;
  }

  function initTransitions() {
    if (!overlay) return;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!shouldIntercept(e, a)) return;
      e.preventDefault();
      leave(a.href, a);
    });

    // Prefetch on intent so the red screen is short
    var prefetched = {};
    function prefetch(e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || prefetched[a.href]) return;
      try {
        var u = new URL(a.href, location.href);
        if (u.origin !== location.origin || /\/(cart|checkout|account)/.test(u.pathname)) return;
      } catch (err) { return; }
      prefetched[a.href] = true;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = a.href;
      document.head.appendChild(l);
    }
    document.addEventListener('pointerover', prefetch, { passive: true });
    document.addEventListener('touchstart', prefetch, { passive: true });

    // Back/forward cache: never restore a covered page
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      leaving = false;
      html.classList.remove('as-arriving', 'as-leaving-fade', 'as-intro');
      if (overlay) {
        overlay.classList.remove('is-lit');
        if (overlay.getAnimations) overlay.getAnimations({ subtree: true }).forEach(function (an) { an.cancel(); });
        overlay.removeAttribute('style');
        $$('.as-nt__logo, .as-nt__word, .as-nt__svg path, [data-as-nt-text]', overlay).forEach(function (el) { el.removeAttribute('style'); });
      }
      if (gsapReady()) {
        window.gsap.set(overlay, { clearProps: 'all' });
        var page = $('.page-wrapper');
        if (page) window.gsap.set(page, { clearProps: 'all' });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* MODELS / ITEMS toggle                                               */
  /* ------------------------------------------------------------------ */
  function initViewToggle() {
    var KEY = 'dnba_card_view';
    var saved = local ? local.getItem(KEY) : null;
    if (saved === 'items') html.classList.add('as-view-items');
    function sync() {
      var items = html.classList.contains('as-view-items');
      $$('[data-as-view]').forEach(function (b) {
        b.setAttribute('aria-pressed', String((b.getAttribute('data-as-view') === 'items') === items));
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-as-view]');
      if (!b) return;
      var items = b.getAttribute('data-as-view') === 'items';
      html.classList.toggle('as-view-items', items);
      if (local) local.setItem(KEY, items ? 'items' : 'models');
      sync();
    });
    sync();
  }

  /* ------------------------------------------------------------------ */
  /* Dialogs: size guide + notify me                                     */
  /* ------------------------------------------------------------------ */
  function initDialogs() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-as-dialog-open]');
      if (opener) {
        var d = document.getElementById(opener.getAttribute('data-as-dialog-open'));
        if (d && typeof d.showModal === 'function') {
          e.preventDefault();
          d.showModal();
          d.__asOpener = opener;
        }
        return;
      }
      var closer = e.target.closest && e.target.closest('[data-as-dialog-close]');
      if (closer) {
        var dlg = closer.closest('dialog');
        if (dlg) dlg.close();
        return;
      }
      // click on backdrop closes
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('as-dialog')) {
        var r = e.target.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
      }
    });
    document.addEventListener('close', function (e) {
      if (e.target.__asOpener) { e.target.__asOpener.focus(); e.target.__asOpener = null; }
    }, true);
  }

  // Notify-me: shows when the selected variant is sold out (theme.js disables the add button).
  function initNotifyMe() {
    $$('[data-as-notify]').forEach(function (wrap) {
      var scope = wrap.closest('[data-product]') || document;
      var btn = $('[data-add-button]', scope);
      function sync() {
        var soldOut = btn ? btn.disabled : false;
        wrap.hidden = !soldOut;
        var variantInput = $('select[name="id"], input[name="id"]', scope);
        var v = $('[data-as-notify-variant]');
        if (v && variantInput) v.value = variantInput.value;
      }
      if (btn) new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      sync();
      var trigger = $('[data-as-notify-open]', wrap);
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          var formId = trigger.getAttribute('data-klaviyo-form');
          if (formId && window._klOnsite) {
            e.preventDefault();
            e.stopPropagation();
            window._klOnsite.push(['openForm', formId]);
          }
        });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Card reveal on scroll                                               */
  /* ------------------------------------------------------------------ */
  function initReveal() {
    if (REDUCE || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('as-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    function scan() {
      $$('.grid__item:not(.as-reveal), .as-reveal-target:not(.as-reveal)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) return; // already on screen: no hidden state
        el.classList.add('as-reveal');
        io.observe(el);
      });
    }
    scan();
    // load more appends grid items
    new MutationObserver(function () { window.requestAnimationFrame(scan); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  function boot() {
    initTransitions();
    initViewToggle();
    initDialogs();
    initNotifyMe();
    initReveal();
    var introRan = runIntro();
    var arrived = !introRan && arrive();
    if (!introRan && !arrived) html.classList.add('as-entered');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
